import { useAuth } from '@components/Auth';
import { ImageThumbnailRatio } from '@components/ImageThumbnailRatio';
import VnrLink from '@components/VnrLink';
import { useRouter } from 'next/router';
import React from 'react';
import { ROLES } from 'src/constants';
import useTranslate from 'src/hook/useTranslate';

import styles from "./AvatarDropdown.module.scss";

const avatar_default = '/images/avatar.png';

const AvatarDropdown = ({ sizeAvatar, rightPosition = -70 }) => {
  const { logout, user } = useAuth();
  const translate = useTranslate();
  const { locale } = useRouter();
  
  const isAdmin = user?.roles?.map((r) => r.code).includes(ROLES.ROLE_VNREBATE_ADMIN);
  const isCustomerCare = user?.roles?.map((r) => r.code).includes(ROLES.ROLE_CUSTOMER_CARE);
  const isBrokerUser = user?.registrationRole === 'COLLABORATOR_BROKER' ? true : false;

  return (
    <div className={styles.avatarWrapper}>
      <div
        style={{ width: sizeAvatar, height: sizeAvatar }}
        className={styles.avatar}
      >
        <ImageThumbnailRatio ratio="1:1" src={user.imageUrl || avatar_default} alt="avatar" />
      </div>

      <div 
        style={{right: rightPosition}}
        className={styles.menuDropDown}
      >
        {isBrokerUser ?
            <VnrLink to="/cv-management.html" className={styles.menuItem}>
              <span>QUẢN LÍ CV</span>
            </VnrLink>
          : <VnrLink to="/dashboard" locale={locale} className={styles.menuItem}>
              <span>{translate?.avatarDropdown?.dashboard}</span>
            </VnrLink>
        }
        
        {isAdmin && (
          <VnrLink to="/admin/dashboard" className={styles.menuItem}>
            <span>QUẢN LÝ</span>
          </VnrLink>
        )}
        {isCustomerCare && (
          <VnrLink to="/admin/ctv-cskh" className={styles.menuItem}>
            <span>QUẢN LÝ KHÁCH HÀNG</span>
          </VnrLink>
        )}
        <VnrLink to="/profile" className={styles.menuItem}>
          <span>{translate?.avatarDropdown?.profile}</span>
        </VnrLink>

        <div className={styles.menuItem} onClick={logout}>
          <span>{translate?.avatarDropdown?.logout}</span>
        </div>
      </div>
    </div>
  );
};

export default AvatarDropdown;
